import { useBreakpoints } from '@vueuse/core'

export default function () {
  const breakpoints = useBreakpoints({
    mobile: 0,
    tablet: 992,
    desktop: 1200,
    largeDesktop: 1400,
  })

  const isLargeDesktop = computed(() => {
    return breakpoints.greater('largeDesktop').value
  })

  const isDesktop = computed(() => {
    return breakpoints.greater('desktop').value
  })

  const isTrueDesktop = computed(() => {
    return breakpoints.greaterOrEqual('desktop').value
  })

  const isMobile = computed(() => {
    return breakpoints.smaller('desktop').value
  })

  const isTablet = computed(() => {
    return breakpoints.greater('tablet').value
  })

  const isTrueTablet = computed(() => {
    return breakpoints.greaterOrEqual('tablet').value
  })

  return {
    isLargeDesktop,
    isDesktop,
    isTrueDesktop,
    isMobile,
    isTablet,
    isTrueTablet,
  }
}
